import styled from 'styled-components'

export const Title = styled.h4.attrs({
  className: 'tds-headline-05'
})`
  ::first-letter {
    text-transform: capitalize;
  }

  margin-top: 0 !important;
  margin-bottom: var(--tds-spacing-layout-8);
  margin-left: var(--tds-spacing-element-16);

  @media (min-width: ${({ theme }) => theme.size.lg}) {
    margin-left: 0;
  }
`

export const StyledHeader = styled.h6.attrs({
  className: 'tds-headline-06 tds-u-mb2 tds-u-mt0'
})``
